export const config = {
  title: "Mintu Nath CENTURY 21 Milestone Team Realty",
  meta: {
    description:
      "Mintu Nath CENTURY 21 Milestone Team Realty provides expert real estate investment and property management services in Queens, New York. Specializing in multi-family and mixed-use properties.",
    keywords: [
      "Real Estate Queens NY",
      "Mintu Equities",
      "Property Management",
      "Real Estate Investment",
      "New York Rental Properties",
    ],
    author: "Mintu Nath CENTURY 21 Milestone Team Realty",
    canonicalUrl: "https://www.mintuequities.com/",
  },
  sections: {
    header: {
      businessName: "Mintu Nath CENTURY 21 Milestone Team Realty",
    },
    sectionB: {
      heroTitle: "Smart Investments in New York Real Estate",
      heroSubtitle:
        "Professional property management and real estate investment services",
      learnAboutText: "Learn More",
      phoneNumber: "6462570172",
      phoneLabel: "(646) 257-0172",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1423395369/photo/young-married-couple-talking-to-a-real-estate-agent-to-sign-a-house-purchase-contract.jpg?s=612x612&w=0&k=20&c=a8JtRWkfru65hVoAKIwVXH1yhlKFUacL86FrH-sFu6g=",
      cardData: [
        {
          title: "Property Management",
          description:
            "Professional management for residential and mixed-use properties in New York City.",
        },
        {
          title: "Investment Strategy",
          description:
            "Smart investment opportunities in high-demand neighborhoods.",
        },
        {
          title: "Tenant Services",
          description:
            "Reliable support for tenants with 24/7 assistance and online rent payments.",
        },
      ],
      description:
        "Mintu Nath CENTURY 21 Milestone Team Realty is dedicated to managing and investing in real estate properties across New York, with a focus on transparency, growth, and community value.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Real estate solutions tailored for investors, property owners, and tenants alike.",
      cards: [
        {
          title: "Buy and Sell",
          description:
            "Helping clients purchase and sell properties with market insights, negotiation, and legal assistance.",
          imageSrc:
            "https://media.istockphoto.com/id/2153366114/photo/real-estate-agent-discussion-to-explaining-about-property-investment-document-with-home-sales.jpg?s=612x612&w=0&k=20&c=AR0OndPnl4cak0JuunNCGImT9Vzbs6AtazAXXmfZO0Q=  ",
          imageAlt: "Buy and Sell",
        },
        {
          title: "Property Acquisition",
          description:
            "Identify and acquire high-potential properties for long-term investment returns.",
          imageSrc:
            "https://media.istockphoto.com/id/2091960956/photo/real-estate-arbitration-law-concept-gavel-justice-hammer-and-house-model-real-estate-law.jpg?s=612x612&w=0&k=20&c=YSckBP9f8tFLecF21fiEWqMKghRO_XXxFi7uKOi9mwc=",
          imageAlt: "Property Acquisition",
        },
        {
          title: "Leasing and Rentals",
          description:
            "Full-service leasing with tenant screening, contracts, and support.",
          imageSrc:
            "https://media.istockphoto.com/id/1004121676/photo/rent-a-room-flat-apartment-house-online-concept.jpg?s=612x612&w=0&k=20&c=V9ZBFCV0WItrc9Iyd0COg1m1Zj24xRv4h95ZQCAfaLM=",
          imageAlt: "Leasing and Rentals",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Financial Reporting",
        "24/7 Emergency Support",
        "Renovation Oversight",
        "Eviction Handling",
        "Legal Compliance Management",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://media.istockphoto.com/id/899471458/photo/purchase-agreement-for-new-house.jpg?s=612x612&w=0&k=20&c=S97ewd-sqqOYk3kX5Wg-1FWJBndPW9AgI0VBHmDHMeA=",
        alt: "Mintu Nath CENTURY 21 Milestone Team Realty",
      },
      aboutText: [
        "Mintu Nath CENTURY 21 Milestone Team Realty is a family-run real estate investment and property management company based in Queens, NY.",
        "We specialize in identifying undervalued properties, adding value through renovations, and managing them with a long-term perspective.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Mintu Nath CENTURY 21 Milestone Team Realty Logo",
      businessName: "Mintu Nath CENTURY 21 Milestone Team Realty  ",
      contact: {
        phone: "6462570172",
        phoneLabel: "(646) 257-0172",
        email: "mintunath07@yahoo.com",
        website: "https://www.mintuequities.com/",
        address: "9104 246th Street, Queens, NY 11426",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "9104 246th Street, Queens, NY 11426",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3021.509898053251!2d-73.7131234!3d40.7255676!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c26263b1798a5d%3A0x2fdef1c9e0f9efc9!2s9104%20246th%20St%2C%20Queens%2C%20NY%2011426!5e0!3m2!1sen!2sus!4v1716463853640",
    },
  },
};

export default config;
